import { ChangeDetectorRef, Component, LOCALE_ID, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { MsalService } from "@azure/msal-angular";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { of, Subscription, switchMap } from "rxjs";
import { SharedModule } from "../../core/shared.module";
import { Utente } from "../../interfaces/user";
import { AppService } from "../../service/app.service";
import { LoaderService } from "../../service/loader.service";
import { NotificationService } from "../../service/notification.service";
import { tipologicaInterface } from "../../interfaces/tipologica.interface";
import { FiltroElencoRisorseComponent } from "../../shared/components/filtro-elenco-risorse/filtro-elenco-risorse.component";
import { TabellaElencoRisorseComponent } from "../../shared/components/tabella-elenco-risorse/tabella-elenco-risorse.component";
import { MatSidenav } from "@angular/material/sidenav";
import { RisorseService } from "../../service/risorse.service";
import { Attori } from "../../shared/enum/attori.enum";
import { ElencoRisorse } from "../../interfaces/elenco-risorse.interface";
import { CurrentSort } from "../../interfaces/table.interface";
import { AnagraficaTimesheet } from "../../interfaces/timesheet.interface";
import { SelectionModel } from "@angular/cdk/collections";
import { LoadingModal } from "../../shared/components/loading-modal/loading.modal";
import { Risorsa } from "../../interfaces/risorse.interface";
import { ConfirmationModal } from "../../shared/components/confirmationModal/confirmation.modal";
import { filtroElencoRisorseVuoto } from "../../interfaces/filtro-elenco-risorse.interface";
import { FiltroService } from "../../service/filtro.service";
import { ElencoRisorseService } from "../../service/elenco-risorse.service";

@Component({
  selector: 'app-homepage',
  standalone: true,
  imports: [
    SharedModule,
    NgxSkeletonLoaderModule,
    FiltroElencoRisorseComponent,
    TabellaElencoRisorseComponent
  ],
  templateUrl: './homepage.component.html',
  providers: [{ provide: LOCALE_ID, useValue: 'it-IT' }],
})
export class HomepageComponent {
  constructor(
    private loader: LoaderService,
    private router: Router,
    private route: ActivatedRoute,
    private authService: MsalService,
    private appService: AppService,
    private dialog: MatDialog,
    private risorseService: RisorseService,
    private elencoRisorseService: ElencoRisorseService,
    private notificationService: NotificationService,
    private filtroService: FiltroService,
    private cd: ChangeDetectorRef,
  ) {}

  pageSubscriptions: Subscription = new Subscription();
  selection: SelectionModel<any> = new SelectionModel<any>(true, []);
  selectedData: any = [];
  componentLoaded = false;
  user = this.authService.instance.getAllAccounts()[0];
  utente: Utente = this.appService.user;
  attore = this.appService.attore;
  attori = Attori;
  form: any = {};
  @ViewChild('sidenav') sidenav!: MatSidenav;
  @ViewChild(TabellaElencoRisorseComponent) tabellaElencoRisorseComponent!: TabellaElencoRisorseComponent;
  anagraficaTimesheet: AnagraficaTimesheet | null = null;
  elencoRisorse: ElencoRisorse[] = [];
  uoPrimoLivello: tipologicaInterface[] = [];
  elencoCount: number = 0;
  totalPages: number = 0;
  currentPage: number = 0;
  currentSort: CurrentSort = {
    flagAsc: true,
    orderBy: '',
  };
  pageOffset: number = 10;
  conteggioCoincidenze: number = 0;
  timesheetApprovati: boolean = false;

  ngOnInit(): void {
    this.route.data.subscribe((data) => {
      this.elencoRisorse = data['data'].elencoRisorse;
      this.elencoCount = data['data'].elencoRisorseCount;
      this.anagraficaTimesheet = data['data'].anagraficaTimesheet;
      this.elencoRisorseService.commesse = data['data'].commesse;
      this.elencoRisorseService.uoPrimoLivello = data['data'].uoPrimoLivello;
      this.uoPrimoLivello = data['data'].uoPrimoLivello;
      this.conteggioCoincidenze = data['data'].conteggioCoincidenze;
      this.timesheetApprovati = data['data'].timesheetApprovati;
      this.totalPages = Math.ceil(this.elencoCount / this.pageOffset);
      this.appService.timestamp = '';
    });
    this.cd.detectChanges();
    this.componentLoaded = true;
    this.loader.hide();
  }

  iconClick(event: any) {
    if (event.columnDef === 'dettaglio') {
      this.risorseService.risorsa = {};
      this.risorseService.risorsa.nomeRisorsa = event.item.nomeRisorsa;
      this.risorseService.risorsa.risorsa = event.item.risorsa;
      this.appService.timestamp = event.item.timestamp;
      this.goToTimesheet();
    }
    if (event.columnDef === 'approvazione') {
      const dialogRef = this.dialog.open(ConfirmationModal, {
        data: {
          title: 'Attenzione',
          text: `L'approvazione ha effetto sul Timesheet di ${event.item.nomeRisorsa}.`,
        },
        autoFocus: false,
        disableClose: true,
        width: 'calc(100% - 30px)',
        maxWidth: '600px',
      });
      this.pageSubscriptions.add(
      dialogRef
        .afterClosed()
        .pipe(
          switchMap((result) => {
            if (!result) {
              return of(null);
            }
            this.loader.show();
            return this.elencoRisorseService.approvaRisorsa([
              event.item.risorsa,
            ]);
          })
        )
        .subscribe({
          next: (result) => {
            if (result) {
              this.updateData();
              this.notificationService.success(
                'Operazione completata con successo',
                5000
              );
              this.selectedData = [];
              this.selection = new SelectionModel<any>(true, []);
            }
          },
          error: () => this.loader.hide(),
          complete: () => this.loader.hide(),
        })
    );
    }
  }

  search(event: any) {
    this.form = event;
    this.sidenav.close();
    if (this.tabellaElencoRisorseComponent) {
      this.tabellaElencoRisorseComponent.handleSearchEvent(event);
    }
  }

  isApprovaTuttiDisabled(): boolean {
  return this.elencoRisorse.length === 0 ||
    this.timesheetApprovati
}

  goToTimesheet(): void {
    this.loader.show();
    this.router.navigate([`dettaglio-risorsa`]);
  }

  goToRiepilogoModifiche(): void {
    this.loader.show();
    this.router.navigate([`riepilogo-modifiche`]);
  }

  goToStoricoDeleghe(): void {
    this.loader.show();
    this.router.navigate([`gestione-deleghe`]);
  }

  masterSelection(event: any) {
    if (event) {
      this.selectedData = event.selected;
    }
  }

  exportDataToExcel(): void {
    const dialogRef = this.dialog.open(LoadingModal, {
      autoFocus: false,
      width: 'calc(100% - 30px)',
      maxWidth: '900px',
      disableClose: true,
    });
    this.tabellaElencoRisorseComponent.exportDataToExcel();
    dialogRef.close();
  }

  approveItems(flagAll: boolean = false): void {
    const dialogRef = this.dialog.open(ConfirmationModal, {
      data: {
        title: 'Attenzione',
        text: `L'approvazione ha effetto su tutti i Timesheet ${flagAll ? 'presenti a sistema' : 'selezionati'}.`,
      },
      autoFocus: false,
      disableClose: true,
      width: 'calc(100% - 30px)',
      maxWidth: '600px',
    });
    const matricole = this.selectedData.map(
      (risorsa: Risorsa) => risorsa.risorsa
    );
    this.appService.timestamp = this.elencoRisorse[0]?.timestamp ?? '';

    this.pageSubscriptions.add(
      dialogRef
        .afterClosed()
        .pipe(
          switchMap((result) => {
            if (!result) {
              return of(null);
            }
            this.loader.show();
            if (flagAll) {
              return this.elencoRisorseService.approvazioneMassiva();
            } else {
              return this.elencoRisorseService.approvaRisorsa(matricole);
            }
          }),
          switchMap(() => {
            return this.elencoRisorseService.timesheetApprovati();
          })
        )
        .subscribe({
          next: (result) => {
            this.timesheetApprovati = result;
            this.updateData();
            this.notificationService.success(
              'Operazione completata con successo',
              5000
            );
            this.selectedData = [];
            this.selection = new SelectionModel<any>(true, []);
          },
          error: () => this.loader.hide(),
          complete: () => this.loader.hide(),
        })
    );
  }

  updateData(): void {
    this.tabellaElencoRisorseComponent.handleSearchEvent(filtroElencoRisorseVuoto);
    this.cd.detectChanges();
  }

  ngOnDestroy(): void {
    this.pageSubscriptions.unsubscribe();
  }
}
